module.exports = __webpack_public_path__ + "static/media/ing.f0326f7f.png";